import React from 'react';
import Heading from '@vfuk/core-heading';
import Button from '@vfuk/core-button';
import { BusinessQuestionsProps } from '../../Types/BusinessQuestionsTypes';
import {
  ButtonsAreaWrapper,
  ButtonWrapper,
  HeadingWrapper,
} from '../../styles/SectionAssessmentAboutBusiness.styles';

const BusinessQuestions = ({
  content,
  item,
  index,
  firstsetquestions,
  selectedResponse,
  getQuestionImage,
  nextEvent,
}: BusinessQuestionsProps) => {
  const htmlAttributes = {
    dataAttributes: {
      'data-testid': index + '-' + item.id,
    },
  };

  return (
    <div id="carouselItem" className={`question` + [index + 2]}>
      <div>
        <img className="sureyQueImage" src={getQuestionImage(index + 1)} />
      </div>
      <div className="questionStyle">
        {`${content.questionNumberText1} ${index + 2} ${
          content.questionNumberText2
        } ${firstsetquestions.length + 3}`}
      </div>
      <HeadingWrapper>
        <Heading text={item.questionText} weight={2} size={3} noMargin={true} />
      </HeadingWrapper>
      <div className="asses-helper-text">{content.headingText[index]}</div>
      <ButtonsAreaWrapper>
        {item.responseOption.map((value: string, index: number) => (
          <ButtonWrapper key={index}>
            <Button
              className={item.id + 'check'}
              htmlAttributes={{ ...htmlAttributes }}
              text={value}
              appearance={value === selectedResponse ? 'secondary' : 'alt1'}
              title={value}
              onClick={e => {
                nextEvent(item.id, value);
                e.currentTarget.blur();
              }}
            />
          </ButtonWrapper>
        ))}
      </ButtonsAreaWrapper>
    </div>
  );
};

export default BusinessQuestions;
